import * as React from 'react';

export const CrossThin: ReactFCWithChildren<JSX.IntrinsicElements['svg']> = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path
      fill="#737387"
      fillRule="evenodd"
      d="M10 9.221l5.06-5.06a.55.55 0 1 1 .779.779L10.779 10l5.06 5.06a.55.55 0 1 1-.779.779L10 10.779l-5.06 5.06a.55.55 0 1 1-.779-.779L9.221 10l-5.06-5.06a.55.55 0 1 1 .779-.779L10 9.221z"
    />
  </svg>
);

export default CrossThin;
